var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-list-group-item',{staticClass:"d-flex shadow"},[_c('div',{staticClass:"profileImageBody rounded-circle mx-4"},[_c('img',{staticClass:"h-100 w-100 rounded-circle",attrs:{"src":_vm.imgsrc}})]),_c('p',{staticClass:"my-auto h6 font-weight-bold"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }